import { ScheduleTemplateListItem } from "@common/schemas/domains/accounting/scheduleTemplate.schema";
import { canScheduleDocument } from "@common/helpers/domains/accounting/scheduleDocumentFit";
import { ScheduleSourceType } from "@common/types/domains/accounting/schedule";

type BillScheduleMode = Pick<
    ScheduleTemplateListItem,
    "type" | "expenseSubMode"
>;

/**
 * Bills carry expense: prepaid, deferred and accrued expense policies apply,
 * revenue and fixed asset ones do not (backend schedule-source-support.helper.ts).
 */
export function canScheduleBill(template: BillScheduleMode): boolean {
    return canScheduleDocument({
        template,
        documentType: ScheduleSourceType.bill,
    });
}

/** The policies a bill or bill line Schedule picker offers. */
export function filterTemplatesForBill<TTemplate extends BillScheduleMode>(
    templates: TTemplate[] | undefined,
): TTemplate[] {
    return (templates ?? []).filter(canScheduleBill);
}
